import { useEffect, useRef, useState, useCallback } from 'react';
import { toast } from 'sonner';

const API_BASE = window.location.origin;
const CHECK_INTERVAL = 60000; // Check every 60 seconds

export function useAutoUpdate() {
  const knownVersion = useRef(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const checkVersion = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/version`, { credentials: 'include' });
      if (!res.ok) return;
      const data = await res.json();
      const serverVersion = data.version;

      if (!knownVersion.current) {
        // First check — store current version
        knownVersion.current = serverVersion;
        return;
      }

      if (serverVersion !== knownVersion.current) {
        // New version detected!
        setUpdateAvailable(true);
        toast.info('New update available! Refreshing...', { duration: 2000 });
        // Auto-reload after short delay so user sees the toast
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      }
    } catch (err) {
      // Silently ignore — network issues shouldn't crash the app
    }
  }, []);

  useEffect(() => {
    // Initial check
    checkVersion();
    // Periodic check
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, [checkVersion]);

  return { updateAvailable };
}
